import React, { FunctionComponent, PropsWithChildren } from 'react'
import { useTiaUI, BoxProps, Box } from './..'

// inspiration from @theme-ui/src/components/SVG
const SvgIcon = (props: BoxProps) => (
    <Box
        as="svg"
        // @ts-ignore: Here, I'm using the same code as @theme-ui/src/components/SVG
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        {...props}
    />
)

export type IconProps = BoxProps & { color?: string }

const Close: FunctionComponent<
    React.PropsWithChildren<PropsWithChildren<IconProps>>
> = props => {
    const { color: propColor, ...boxProps } = props
    const { theme } = useTiaUI()
    // @ts-ignore: theme is never null
    const color = theme.colors[propColor] || propColor

    return (
        <SvgIcon {...boxProps} aria-label="close icon">
            <path
                d="M18.2997 5.70999C18.1129 5.52273 17.8592 5.4175 17.5947 5.4175C17.3302 5.4175 17.0766 5.52273 16.8897 5.70999L11.9997 10.59L7.10973 5.69999C6.9229 5.51273 6.66924 5.4075 6.40473 5.4075C6.14021 5.4075 5.88656 5.51273 5.69973 5.69999C5.30973 6.08999 5.30973 6.71999 5.69973 7.10999L10.5897 12L5.69973 16.89C5.30973 17.28 5.30973 17.91 5.69973 18.3C6.08973 18.69 6.71973 18.69 7.10973 18.3L11.9997 13.41L16.8897 18.3C17.2797 18.69 17.9097 18.69 18.2997 18.3C18.6897 17.91 18.6897 17.28 18.2997 16.89L13.4097 12L18.2997 7.10999C18.6797 6.72999 18.6797 6.08999 18.2997 5.70999Z"
                fill={color as string}
            />
        </SvgIcon>
    )
}

export type IconsEnum = 'Close'

// Exporting this way since the export in index.tsx, "export * as Icon from "./components/Icons" triggers an error on parcel
// exactly this issue: https://github.com/parcel-bundler/parcel/issues/5911
// export all icons as Icon to be able to use sth like: <Icon.Close>
// by using your IDE, you will have an autocomplete like Icon.<all_available_icons>
export const Icon: Record<
    IconsEnum,
    FunctionComponent<React.PropsWithChildren<PropsWithChildren<IconProps>>>
> = {
    Close
}
